const states = {
    botparams_details: {
        variables: [],
        actions: [],
        loaders: {
            variables_loading: false,
            variables_load_error: false,
            variable_updating: false,
            variable_creating: false,
            actions_loading: false,
            actions_load_error: false,
        }
    }
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/botparams_details/states.js